import { Form, Table } from 'react-bootstrap'
import { Edit, Trash2 } from 'lucide-react'
import { BookingSlotType } from '@/types/BookingSlotType'
import { CompanyType } from '@/types/CompanyType'

type TableBookingType = {
    bookings: CompanyType[]
    myRole: string | undefined
    handleUpdateState: (id: number, state: boolean) => void
    handleShowEditForm: (booking: BookingSlotType) => void
    handleDelete: (id: number) => void
}

export default function TableBooking ({tableBookingProps}: {tableBookingProps: TableBookingType}) {
const { bookings, myRole, handleUpdateState, handleShowEditForm, handleDelete } = tableBookingProps
    return (
        <Table responsive >
              <thead>
                <tr>
                  <th>Société</th>
                  <th>Machines</th>
                </tr>
              </thead>
              <tbody>
                {bookings.map((booking) => (
                  <tr key={booking.id}>
                    <td className='' style={{ width: '15%' }}>
                      {booking.name}
                    </td>
                    <td className='p-0 border-0'>
                      <Table responsive striped className='mb-0'>
                        <thead className='border-top-0'>
                          <tr className=''>
                             {myRole === import.meta.env.VITE_APP_ROLE_SUPER_ADMIN && (
                            <th>ID</th>
                             )}
                            <th style={{ width: '350px' }}>Emplacement</th>
                            <th>Temp.</th>
                            <th>Dim.</th>
                            <th>Casiers réservés</th>
                            <th>Casiers dispo</th>
                            <th style={{ width: '200px' }}>Etat</th>
                            {myRole === import.meta.env.VITE_APP_ROLE_SUPER_ADMIN && (
                            <th>Actions</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {booking.bookingSlots.map((boxZone) => (
                            <tr key={boxZone.id}>
                               {myRole === import.meta.env.VITE_APP_ROLE_SUPER_ADMIN && (
                              <td>{boxZone.id}</td>
                               )}
                              <td>{boxZone?.slot?.temperatureZone?.locker?.location}</td>
                              <td>{boxZone?.slot?.temperatureZone?.name}</td>
                              <td>{boxZone?.slot?.size}</td>
                              <td>{boxZone?.capacity}</td>
                              <td>{boxZone?.available}</td>
                              <td>
                                {' '}
                                <Form.Check
                                  onClick={() =>
                                    handleUpdateState(Number(boxZone?.id), !boxZone?.active)
                                  }
                                  defaultChecked={boxZone?.active}
                                  type='switch'
                                  label={boxZone?.active ? 'Activé' : 'Désactivé'}
                                  id={
                                    boxZone?.active
                                      ? 'custom-switch'
                                      : 'disabled-custom-switch'
                                  }
                                />
                              </td>
                               {myRole === import.meta.env.VITE_APP_ROLE_SUPER_ADMIN && (
                              <td>
                                {' '}
                                <Edit
                                  size={20}
                                  className='text-muted me-2 cursor-pointer'
                                  onClick={() => handleShowEditForm(booking)}
                                />
                                <Trash2
                                  size={20}
                                  className='text-danger cursor-pointer'
                                  onClick={() => handleDelete(Number(booking?.id))}
                                />
                              </td>
                               )}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
    )
}